const isImageLink = (url) => {
  if (!url) return false;
  const regex = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;

  const fileName = url.slice(url.lastIndexOf("/") + 1);
  return regex.test(url) || fileName.toUpperCase().startsWith("IMG");
};

export default isImageLink;
